import { useEffect } from "react";
import { PAGE_SEO } from "../mock";

const setMeta = (attribute, name, content) => {
  const selector = `meta[${attribute}="${name}"]`;
  const element = document.querySelector(selector);
  if (element) element.setAttribute("content", content);
};

const PageSeo = ({ lang }) => {
  useEffect(() => {
    const seo = PAGE_SEO[lang];
    document.title = seo.title;
    setMeta("name", "description", seo.description);
    setMeta("name", "keywords", seo.keywords);
    setMeta("property", "og:locale", seo.locale);
    setMeta("property", "og:title", seo.title);
    setMeta("property", "og:description", seo.description);
    setMeta("property", "og:url", seo.url);
    setMeta("property", "og:image:alt", seo.imageAlt);
    setMeta("name", "twitter:title", seo.title);
    setMeta("name", "twitter:description", seo.description);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", seo.url);

    const schemaElement = document.querySelector('script[type="application/ld+json"]');
    if (schemaElement) {
      const schema = JSON.parse(schemaElement.textContent);
      const business = schema["@graph"]?.[0];
      const person = schema["@graph"]?.[1];
      const website = schema["@graph"]?.[2];
      if (business) {
        business.url = seo.url;
        business.description = seo.schemaDescription;
      }
      if (person) person.url = seo.url;
      if (website) {
        website.url = seo.url;
        website.inLanguage = lang;
      }
      schemaElement.textContent = JSON.stringify(schema);
    }
  }, [lang]);

  return null;
};

export default PageSeo;